export enum CourseApplicationStatus {
  Pending = "Pending",
  Approve = "Approve",
  Reject = "Reject",
}

// TODO: to be removed when more added
export default {};
